import { PAGE_TYPE } from '@/constants/index'
import { useStore } from '@/store/index'
import { showNotification } from '@gate/gui'
import { useClipboard } from '@mantine/hooks'
import { useMemoizedFn } from 'ahooks'
import { useTranslation } from 'next-i18next'

const useCopy = (message?: string) => {
  const clipboard = useClipboard({ timeout: 500 })
  const { pageType } = useStore().globalStore
  const { t } = useTranslation(pageType === PAGE_TYPE.COIN_DETAIL ? ['coin_details_v2'] : ['price'])

  const runCopy = useMemoizedFn((str: string) => {
    clipboard.copy(str)

    showNotification({
      id: message,
      message: message ?? (pageType === PAGE_TYPE.COIN_DETAIL ? t('CopiedSuccessfully') : t('P.CSF')),
      type: 'success',
    })
  })

  return { runCopy }
}

export default useCopy
